import ClientSelection from "./pages/ClientSelection";
import Debug from "./pages/Debug";
import Home from "./pages/Home";
import RoleSelection from "./pages/RoleSelection";

const routes = [
  { path: "", element: Home, openAccess: true },
  { path: "debug", element: Debug, openAccess: true },
  { path: "roles", element: RoleSelection },
  { path: "clients", element: ClientSelection },
];
export default routes;
